import { Component, OnInit } from '@angular/core';

import { OkAloneService } from 'src/app/ok-alone.service';

import Utils from 'src/app/utils';

import moment from 'moment';

@Component({
  selector: 'app-last-sync',
  templateUrl: './last-sync.component.html',
  styleUrls: ['./last-sync.component.scss']
})
export class LastSyncComponent implements OnInit {

  syncs: any;

  group:any = null;

  monitors:any = [];
  groups:any = [];
  statuses = [
    {'id':'ok','name':'Ok'},
    {'id':'overdue','name':'Overdue'},
    {'id':'help','name':'Help'},
    {'id':'','name':'Inactive'}
  ];

  filter: any = {
    start: "",
    end: "",
    group: "",
    status: ""
  };
  selected: any;

  u = Utils;

  constructor(public okService: OkAloneService) { }

  ngOnInit(): void {

    this.selected = { startDate: moment().subtract(1, 'months'), endDate: moment() };

    this.getWorkers();

  }

  getWorkers(){

    let filter:any = { ...this.filter };
    filter.start = this.selected.startDate.format("YYYY-MM-DD");
    filter.end = this.selected.endDate.format("YYYY-MM-DD");
    filter.group = this.filter.group ? this.filter.group : "";
    filter.status = this.filter.status ? this.filter.status.join(",") : "";

    this.okService.get('reports/lastsync',filter)
    .subscribe((data) => {

      this.syncs = data.body;
      this.groups = this.okService.groups;

      console.log('data',this.syncs);

    });

  }

  updateFilter(){

    this.getWorkers();

  }

  clearFilter(){
    this.filter = {
      start: "",
      end: "",
      group: "",
      status: []
    };
    this.updateFilter();
  }

  export(){

    let fields:any = {'export':true};
    fields['start'] = this.selected.startDate.format("YYYY-MM-DD");
    fields['end'] = this.selected.endDate.format("YYYY-MM-DD");
    fields['group'] = this.filter.group ? this.filter.group : "";
    fields['status'] = this.filter.status ? this.filter.status.join(",") : "";

    this.okService.download("reports/lastsync",fields);

  }

}
